import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const BatteryIntelligenceIcon = ({
  fill = "#989898",
  isSelected = false,
  ...props
}) => (
  <SvgIcon {...props} viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
    {/* Heart shape */}
    <path
      d="M7.9165 3.29271C6.51722 0.11128 3.25763 -0.140313 1.73702 1.21504C0.499509 2.29445 -0.0909388 4.99705 1.03334 7.45616C2.98263 11.6845 7.9165 13.9489 7.9165 13.9489C7.9165 13.9489 12.8504 11.7251 14.7997 7.49674C15.9239 5.06197 15.3335 2.3675 14.096 1.25562C12.5754 -0.140313 9.31578 0.11128 7.9165 3.29271Z"
      fill={isSelected ? "#4D44D8" : "#989898"}
      stroke={isSelected ? "#4D44D8" : "#989898"}
      strokeWidth="0.871212"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* ECG / pulse line */}
    <path
      d="M0.912842 7.16426H4.682L7.1085 9.59903L9.535 4.72949L11.1527 7.16426H14.9218"
      stroke={isSelected ? "#BBC5FF" : "#C9C9C9"}
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export default BatteryIntelligenceIcon;
